import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const observer = lozad('.lazy', {
	rootMargin: '10px 0px', // syntax similar to that of CSS Margin
	threshold: 0.1, // ratio of element convergence
	loaded: function(el) {
        // Custom implementation on a loaded element
        el.classList.add('loaded');
    },
	});
	observer.observe();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js